import { APIError } from '../../../api/types';

export type APIActionTypes = {
  fetch: string;
  success: string;
  update: string;
  fail: string;
  clear: string;
};

export type Action<T = object> = {
  type: string;
  payload: any;
};

export function createAPIActionTypes(actionKey: string): APIActionTypes {
  return {
    fetch: `${actionKey}/fetch`,
    success: `${actionKey}/fulfilled`,
    update: `${actionKey}/update`,
    fail: `${actionKey}/rejected`,
    clear: `${actionKey}/clear`,
  } as const;
}

export type APIState<T> = {
  loaded: boolean;
  loading: boolean;
  payload: T;
  error?: APIError;
};

export const createAPIReducer = <Payload>(actionTypes: APIActionTypes) => {
  return function(
    state = {
      loaded: false,
      loading: false,
      // payload: {} as Payload,
      payload: null,
    },
    action: Action
  ): APIState<Payload> {
    switch (action.type) {
      case actionTypes.fetch:
        return {
          ...state,
          loaded: false,
          loading: true,
        };
      case actionTypes.success:
      case actionTypes.update:
        return {
          ...state,
          loaded: true,
          loading: false,
          payload: action.payload,
        };
      case actionTypes.fail:
        return {
          ...state,
          loaded: false,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
};
